import { STOCK_TAKING_CAR_MANAGEMENT_FIELDS } from './constants'

export function takingCarManagementFields(fields) {
  return dispatch => {
    dispatch({
      type: STOCK_TAKING_CAR_MANAGEMENT_FIELDS,
      data: fields
    })
  }
}

export function reducer(state, action) {
  if (action.type === STOCK_TAKING_CAR_MANAGEMENT_FIELDS) {
      return {
        ...state,
        takingCarManagement: {
          ...state.takingCarManagement,
          fields: action.data
        }
      }
  }
  else{
      return state
  }      
}
